(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/context-menu.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/context-menu.js');

'use strict';

svs.matchen.views.ContextMenu = Marionette.View.extend({
  attachHtml(view) {
    this.el.innerHTML = '';
    const children = view.el.childNodes;
    while (children.length > 0) {
      this.el.appendChild(children[0]);
    }
    view.setElement(this.el, true);
  },
  clickOdds() {
    if (svs.core.detect.formfactor.desktop()) {
      const matchenSliderFolder = $('.matchen-slider-folder');
      const matchenSliderFolderDimmer = $('.matchen-odds-dimmer');
      if (this.matchOddsToogle) {
        matchenSliderFolder.removeClass('no-transition').toggleClass('matchen-slider-folder-open');
        matchenSliderFolderDimmer.removeClass('no-transition').toggleClass('matchen-odds-dimmer-visible');
      } else {
        matchenSliderFolder.addClass('no-transition').toggleClass('matchen-slider-folder-open');
        matchenSliderFolderDimmer.addClass('no-transition').toggleClass('matchen-odds-dimmer-visible');
      }
    } else {
      svs.components.Modal.show(svs.matchen.views.MatchenOdds, {
        model: this.model
      }, {
        headerClass: 'matchen-modal-header',
        leftButton: {
          visible: false
        },
        rightButton: {
          cssClass: 'btn-transparent-inverted',
          text: 'Stäng'
        },
        title: 'Odds'
      });
    }
  },
  clickSpelguide() {
    svs.matchen.utils.showGameGuide();
  },
  clickTipsinfo() {
    svs.components.Modal.show(svs.matchen.views.TipsInfo, {
      model: svs.matchen.tipsInfo
    }, {
      title: 'Tipsinfo',
      headerClass: 'matchen-modal-header',
      leftButton: {
        visible: false
      },
      rightButton: {
        cssClass: 'btn-transparent-inverted',
        callback() {
          _.defer(() => {
            this.model.setGoalAvgTrend(this.viewModel.goalAvgTrend);
            this.model.setSvenskaFolket(this.viewModel.svenskaFolket);
            this.model.displayActionBar(true);
          });
          return true;
        }
      }
    });
  },
  clickXpert() {
    svs.components.Modal.show(svs.matchen.views.Xperten, {
      model: this.model.get('xperten')
    }, {
      headerClass: 'matchen-modal-header',
      leftButton: {
        cssClass: 'btn-transparent-inverted'
      },
      modalHistory: false,
      rightButton: {
        callback: () => svs.matchen.views.drawDetail.confirmClearCoupon(),
        cssClass: 'btn-transparent-inverted',
        disabled: !this.model.get('xperten').getSystemSize()
      },
      title: 'PIX!'
    });
  },
  events: {
    'click @ui.odds': 'clickOdds',
    'click @ui.spelguide': 'clickSpelguide',
    'click @ui.tipsinfo': 'clickTipsinfo',
    'click @ui.xpert': 'clickXpert'
  },
  initialize() {
    this.listenTo(this.model.get('xperten'), 'change', this.render);
    const openXperten = svs.components.Storage.browser.get(svs.matchen.XPERTEN, svs.matchen.STORAGE_NAME);
    if (openXperten) {
      svs.components.Storage.browser.remove(svs.matchen.XPERTEN, svs.matchen.STORAGE_NAME, () => {
        this.clickXpert();
      });
    }
  },
  template(data) {
    return svs.matchen.templates.context_menu(data);
  },
  ui: {
    odds: '.js-odds',
    spelguide: '.js-spelguide',
    tipsinfo: '.js-tipsinfo',
    xpert: '.js-xpert'
  }
});

 })(window);